import React from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';

import { AccentText } from '@/components';

import { DelinquentClaimsStatisticTileProps } from '../DelinquentClaimsStatistic.types';

const TEST_ID_PREFIX = 'dashboard_statistics_delinquent-claims';

export const DelinquentClaimsStatisticTile: React.FC<DelinquentClaimsStatisticTileProps> = ({
  testId,
  label,
  value,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Box
        data-testid={`${TEST_ID_PREFIX}_${testId}-tile`}
        background="canvas"
        border={{ color: 'border2', size: '1px' }}
        round="container2Round"
        pad={{ horizontal: 'spacing12', vertical: 'spacing8' }}
        direction="column"
        justify="center"
        gap="spacing2"
        style={{ flex: 1 }}
      >
        <ShimmerBox
          data-testid={`${TEST_ID_PREFIX}_${testId}-loader`}
          round="checkboxRound"
          width="77px"
          height="36px"
        />
        <ShimmerBox round="checkboxRound" width="100%" height="20px" margin={{ top: 'spacing2' }} />
      </Box>
    );
  }

  return (
    <Box
      data-testid={`${TEST_ID_PREFIX}_${testId}-tile`}
      background="canvas"
      border={{ color: 'border2', size: '1px' }}
      round="container2Round"
      pad={{ horizontal: 'spacing12', vertical: 'spacing8' }}
      direction="column"
      justify="center"
      gap="spacing2"
      style={{ flex: 1 }}
    >
      <AccentText data-testid={`${TEST_ID_PREFIX}_${testId}-count`} size="2xl" weight={700}>
        {value || 0}
      </AccentText>
      <Text
        data-testid={`${TEST_ID_PREFIX}_${testId}-label`}
        truncate
        title={label}
        size="medium"
        weight={400}
        color="textBody"
      >
        {label}
      </Text>
    </Box>
  );
};

export default DelinquentClaimsStatisticTile;
